import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../../hooks/useSettings";

const FooterCopyright = ({ footerLogo, spaceBottomClass, colorClass, backgroundType = "light" }) => {
  const { logoLight, logoDark, siteName, companyPhone, companyEmail } = useSettings();

  // Determine which logo to use based on background type
  let logoUrl = footerLogo; // Use prop if provided
  
  if (!logoUrl) {
    switch (backgroundType) {
      case "light":
        logoUrl = logoDark; // Use dark logo on light background
        break;
      case "dark":
        logoUrl = logoLight; // Use light logo on dark background
        break;
      default:
        logoUrl = logoDark; // Default to dark logo (assuming light background)
        break;
    }
  }

  return (
    <div
      className={`copyright ${spaceBottomClass ? spaceBottomClass : ""} ${
        colorClass ? colorClass : ""
      }`}
    >
      <div className="footer-logo">
        <Link to={process.env.PUBLIC_URL + "/"}>
          <img style={{ width: "100px" }} alt="" src={logoUrl} />
        </Link>
      </div>
      <p>
        © 2025{" "}
        <a href="/" rel="noopener noreferrer">
          {siteName}
        </a>
        .<br /> All Rights Reserved
      </p>
      {(companyPhone || companyEmail) && (
        <div className="footer-contact">
          {companyPhone && <p>Phone: {companyPhone}</p>}
          {companyEmail && <p>Email: {companyEmail}</p>}
        </div>
      )}
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  backgroundType: PropTypes.oneOf(["light", "dark"]),
};

export default FooterCopyright;
